import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { createElement } from 'react';
import { noop } from '../../utils/util.js';
import { Button } from '../Button/Button.js';
import { ButtonMenuContainer } from '../ButtonMenuContainer/ButtonMenuContainer.js';
import { ButtonMenuItem } from '../ButtonMenuItem/ButtonMenuItem.js';
import { ButtonMenuMenu } from '../ButtonMenuMenu/ButtonMenuMenu.js';
import { ButtonMenuTrigger } from '../ButtonMenuTrigger/ButtonMenuTrigger.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["tooltipProps"],
    _excluded2 = ["buttonProps", "onActivate", "inline", "options", "tooltipProps"];
var TooltipButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var tooltipProps = props.tooltipProps,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({
    variant: "dark",
    size: "sm"
  }, tooltipProps), {}, {
    showing: rest["aria-expanded"] ? false : void 0,
    children: /*#__PURE__*/jsx(Button, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref
    }))
  }));
});
TooltipButton.propTypes = {
  "tooltipProps": _PropTypes.object
};
TooltipButton.displayName = "TooltipButton";

function ButtonMenu(props) {
  var buttonProps = props.buttonProps,
      _props$onActivate = props.onActivate,
      _onActivate = _props$onActivate === void 0 ? noop : _props$onActivate,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? true : _props$inline,
      options = props.options,
      tooltipProps = props.tooltipProps,
      rest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/jsxs(ButtonMenuContainer, _objectSpread(_objectSpread({
    inline: inline
  }, rest), {}, {
    children: [/*#__PURE__*/jsx(ButtonMenuTrigger, {
      children: /*#__PURE__*/jsx(TooltipButton, _objectSpread(_objectSpread({}, buttonProps), {}, {
        tooltipProps: tooltipProps
      }))
    }), /*#__PURE__*/jsx(ButtonMenuMenu, {
      children: options.map(function (item, index) {
        return /*#__PURE__*/createElement(ButtonMenuItem, _objectSpread(_objectSpread({}, item), {}, {
          onActivate: function onActivate() {
            return _onActivate(options[index]);
          },
          key: index
        }));
      })
    })]
  }));
}

ButtonMenu.propTypes = {
  "buttonProps": _PropTypes.object.isRequired,
  "inline": _PropTypes.bool,
  "onActivate": _PropTypes.func,
  "options": _PropTypes.arrayOf(_PropTypes.object).isRequired,
  "tooltipProps": _PropTypes.object
};
ButtonMenu.displayName = "ButtonMenu";

export { ButtonMenu };
